import { parse } from '../parser/index.js';
import { compileDialogues } from './dialogues.js';
import { compileStyles } from './styles.js';
export function compile(text) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var tree = parse(text);
  var styles = compileStyles({
    info: tree.info,
    style: tree.styles.style,
    format: tree.styles.format,
    defaultStyle: options.defaultStyle || {}
  });
  return {
    info: tree.info,
    width: tree.info.PlayResX * 1 || null,
    height: tree.info.PlayResY * 1 || null,
    collisions: tree.info.Collisions || 'Normal',
    styles: styles,
    dialogues: compileDialogues({
      styles: styles,
      dialogues: tree.events.dialogue
    })
  };
}